import { User } from "./user";

export class Team {
  id?: number;
  lead?: User;
  members?: User[];

  constructor(init?: Partial<Team>) {
    Object.assign(this, init);
  }

  createDto(): TeamCreateDto {
    return {
      leadId: this.lead?.id,
      memberIds: (this.members || []).map(member => member.id)
    };
  }

  updateDto(): TeamUpdateDto {
    return {
      id: this.id,
      leadId: this.lead?.id,
      memberIds: (this.members || []).map(member => member.id)
    };
  }
}

export interface TeamCreateDto {
  leadId: number;
  memberIds: number[];
}

export interface TeamUpdateDto {
  id: number;
  leadId: number;
  memberIds: number[];
}